export default "__VITE_ASSET__BkiK5EMY__"